var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperClipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.80319 3.83266L7.04194 3.07216L3.23569 6.87766C3.08578 7.02761 2.96688 7.20562 2.88577 7.40153C2.80467 7.59743 2.76294 7.80739 2.76297 8.01943C2.76301 8.23146 2.8048 8.4414 2.88598 8.63728C2.96715 8.83316 3.08611 9.01113 3.23606 9.16104C3.38602 9.31094 3.56403 9.42984 3.75993 9.51095C3.95584 9.59206 4.1658 9.63379 4.37783 9.63375C4.58986 9.63372 4.79981 9.59192 4.99568 9.51075C5.19156 9.42957 5.36953 9.31061 5.51944 9.16066L10.0869 4.59391C10.5916 4.08917 10.875 3.40463 10.875 2.69089C10.8749 1.97715 10.5913 1.29268 10.0866 0.788035C9.58182 0.283394 8.89729 -7.03131e-05 8.18355 1.30825e-08C7.46981 7.03392e-05 6.78533 0.28367 6.28069 0.78841L1.48519 5.58316L1.47469 5.59291C0.00843751 7.05916 0.00843751 9.43516 1.47469 10.9007C2.94094 12.3662 5.31694 12.3662 6.78319 10.9007L6.79294 10.8902L6.79369 10.8909L10.0674 7.61791L9.30619 6.85741L6.03244 10.1297L6.02269 10.1394C4.97869 11.1834 3.28069 11.1834 2.23669 10.1394C1.98766 9.88984 1.79034 9.59356 1.65605 9.26757C1.52176 8.94158 1.45313 8.59229 1.45411 8.23973C1.45508 7.88717 1.52564 7.53826 1.66173 7.21302C1.79783 6.88778 1.99678 6.5926 2.24719 6.34441L2.24644 6.34366L7.04269 1.54891C7.67194 0.91891 8.69644 0.91891 9.32644 1.54891C9.95644 2.17891 9.95569 3.20266 9.32644 3.83191L4.75894 8.39866C4.65672 8.49268 4.52213 8.54358 4.38328 8.54071C4.24442 8.53785 4.11204 8.48145 4.01379 8.38329C3.91554 8.28514 3.85901 8.15281 3.856 8.01396C3.853 7.87511 3.90377 7.74047 3.99769 7.63816L7.80394 3.83191L7.80319 3.83266Z",
    fill: "#49575E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperClipIcon);
export default __webpack_public_path__ + "static/media/paper-clip-icon.54f39aeca5077d0b7cb7132119328780.svg";
export { ForwardRef as ReactComponent };